import React from 'react';

import { bemCssModules } from '@src/utils';

import AppleIcon from './apple.svg';
import GoogleIcon from './google_market.svg';

import style from './AppButtons.scss';

const cn = bemCssModules(style, 'AppButtons');

const APPLE_LINK = 'https://go.onelink.me/app/50d2ae54';
const GOOGLE_LINK = 'https://go.onelink.me/app/11453def';

export type TAppButtons = {
  className?: string;
};

const AppButtons: React.FC<TAppButtons> = ({ className }) => (
  <div className={cn(null, [className])}>
    <a
      className={cn('button')}
      href={APPLE_LINK}
      target="_blank"
      rel="noopener noreferrer nofollow"
    >
      <AppleIcon className={cn('icon')} /> App Store
    </a>
    <a
      className={cn('button')}
      href={GOOGLE_LINK}
      target="_blank"
      rel="noopener noreferrer nofollow"
    >
      <GoogleIcon className={cn('icon')} /> Google Play
    </a>
  </div>
);

export default AppButtons;
